import React, { useEffect } from "react";
import { MapContainer, TileLayer, Polygon, Popup, CircleMarker } from "react-leaflet";
import L from "leaflet";

// Fix default marker icons for webpack
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png",
  iconUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
  shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
});

const swapLngLat = (poly = []) => poly.map(([lng, lat]) => [lat, lng]);

const styleFor = (kind, status) => {
  if (kind === "mineral") {
    if (status === "active") return { color: "#E1B34C", weight: 1.4, fillColor: "#C99A2E", fillOpacity: 0.35 };
    if (status === "pending") return { color: "#7CBFDC", weight: 1.2, fillColor: "#145A7A", fillOpacity: 0.28 };
    if (status === "conflict_review") return { color: "#E67E7E", weight: 1.6, fillColor: "#A93F3F", fillOpacity: 0.35 };
    return { color: "#5F7688", weight: 1, fillColor: "#415363", fillOpacity: 0.15 };
  }
  return { color: "#6BB88A", weight: 1, fillColor: "#2F6B4F", fillOpacity: 0.28 };
};

export const GISMap = ({
  parcels = [],
  minerals = [],
  center = [-19.0, 29.8],
  zoom = 6,
  height = 480,
  onFeatureClick,
}) => {
  return (
    <div className="cad-panel overflow-hidden relative" style={{ height }}>
      <MapContainer
        center={center}
        zoom={zoom}
        scrollWheelZoom
        className="cad-map w-full h-full"
        style={{ height: "100%", width: "100%" }}
      >
        <TileLayer
          attribution='© OpenStreetMap · Cadastre360 demonstration overlay'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        {parcels.map((p) => (
          <Polygon
            key={`p-${p.id}`}
            positions={swapLngLat(p.coordinates || [])}
            pathOptions={styleFor("parcel")}
            eventHandlers={{ click: () => onFeatureClick && onFeatureClick("parcel", p) }}
          >
            <Popup>
              <div className="text-[13px]">
                <div className="font-semibold">{p.parcel_number}</div>
                <div>{p.district}, {p.province}</div>
                <div className="uppercase text-[10px] tracking-widest text-slate-500">{p.land_type}</div>
                <div>{p.area_ha} ha</div>
              </div>
            </Popup>
          </Polygon>
        ))}
        {minerals.map((m) => (
          <Polygon
            key={`m-${m.id}`}
            positions={swapLngLat(m.coordinates || [])}
            pathOptions={styleFor("mineral", m.status)}
            eventHandlers={{ click: () => onFeatureClick && onFeatureClick("mineral", m) }}
          >
            <Popup>
              <div className="text-[13px]">
                <div className="font-semibold">{m.licence_number || m.application_number}</div>
                <div>{m.commodity} · {m.status}</div>
                <div>{m.province}</div>
                <div>{m.area_ha} ha</div>
              </div>
            </Popup>
          </Polygon>
        ))}
        {minerals.length === 0 && parcels.length === 0 && (
          <CircleMarker center={center} radius={8} pathOptions={{ color: "#C99A2E" }}>
            <Popup>No spatial data yet.</Popup>
          </CircleMarker>
        )}
      </MapContainer>
      <div className="absolute top-3 right-3 cad-glass px-3 py-1.5 rounded-sm text-[10px] font-mono-cad uppercase tracking-widest z-[500]">
        {parcels.length + minerals.length} features
      </div>
    </div>
  );
};
